import { Skeleton, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type GachaBoxSkeletonProps = {}

export const GachaBoxSkeleton: Cell<GachaBoxSkeletonProps> = () => (
  <Stack
    sx={{
      display: 'flex',
    }}
    direction="row"
    spacing={4}
  >
    <Skeleton variant="rectangular" width={136} height={102} />
    <Stack
      justifyContent="center"
      sx={{
        flex: 1,
        width: 163,
      }}
    >
      <SkeletonText variant="medium" />
      <SkeletonText variant="small" width="60%" />
    </Stack>
  </Stack>
)
